import { createContext, useContext } from 'react';
import { ReformedBrandItemType, SectionFormType } from './types';
import { BrandType } from 'utils/types';

export type SectionFormContextType = {
  sectionForm: SectionFormType;
  setSectionForm: (k: SectionFormType) => void;
  disabled: boolean;
  setDisabled: (k: boolean) => void;
  handleChange: (name: string, value: string | string[] | boolean) => void;
  brands: BrandType[];
  brandItems: ReformedBrandItemType[];
  isLoadingBrands: boolean;
  isLoadingBrandItems: boolean;
  handleToggle: (polygonId: string) => void;
};

export const SectionFormContext = createContext({} as SectionFormContextType);

const useSectionFormContext = () => {
  const context = useContext(SectionFormContext);
  return context;
};

export default useSectionFormContext;
